export function formatProductLink(permalink: string) {
  const baseUrl = process.env.STORE_URL
  const productType = 'pneu'

  return `${baseUrl}${productType}/${permalink}`
}
